// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TableEmptyView-module__font-s-10___AbABz {
  font-size: 10px !important;
}

.TableEmptyView-module__font-s-12___mc9Tr {
  font-size: 12px !important;
}

.TableEmptyView-module__font-s-13___P2l7I {
  font-size: 13px !important;
}

.TableEmptyView-module__font-s-14___X31Qn {
  font-size: 14px !important;
}

.TableEmptyView-module__font-s-15___SNZ7F {
  font-size: 15px !important;
}

.TableEmptyView-module__font-s-16___fIS2K {
  font-size: 16px !important;
}

.TableEmptyView-module__font-s-18___abvKK {
  font-size: 18px !important;
}

.TableEmptyView-module__font-s-20___xHEMl {
  font-size: 20px !important;
}

.TableEmptyView-module__font-s-22___La9Mj {
  font-size: 22px !important;
}

.TableEmptyView-module__font-s-28___X9qj0 {
  font-size: 28px !important;
}

.TableEmptyView-module__font-w-400___toOUq {
  font-weight: 400 !important;
}

.TableEmptyView-module__font-w-500___Zgfup {
  font-weight: 500 !important;
}

.TableEmptyView-module__font-w-600___wLqwx {
  font-weight: 600 !important;
}

.TableEmptyView-module__font-w-700___kJ_rR {
  font-weight: 700 !important;
}

.TableEmptyView-module__p-5___I46Uc {
  padding: 5px !important;
}

.TableEmptyView-module__p-12___Ttv9S {
  padding: 12px !important;
}

.TableEmptyView-module__p-16___qsYUC {
  padding: 16px !important;
}

.TableEmptyView-module__p-30___WnAYI {
  padding: 30px !important;
}

.TableEmptyView-module__p-b-0___ESBNp {
  padding-bottom: 0 !important;
}

.TableEmptyView-module__p-b-5___jkoOv {
  padding-bottom: 5px !important;
}

.TableEmptyView-module__p-b-10___WUFf1 {
  padding-bottom: 10px !important;
}

.TableEmptyView-module__p-b-12___HfEkX {
  padding-bottom: 12px !important;
}

.TableEmptyView-module__p-b-16___CsjH7 {
  padding-bottom: 16px !important;
}

.TableEmptyView-module__p-b-18___kWhQU {
  padding-bottom: 18px !important;
}

.TableEmptyView-module__p-b-20___nYPT8 {
  padding-bottom: 20px !important;
}

.TableEmptyView-module__p-b-25___kLpqv {
  padding-bottom: 25px !important;
}

.TableEmptyView-module__p-b-30___vyOlm {
  padding-bottom: 30px !important;
}

.TableEmptyView-module__p-b-50___vgOyi {
  padding-bottom: 50px !important;
}

.TableEmptyView-module__p-t-0___hZVvY {
  padding-top: 0 !important;
}

.TableEmptyView-module__p-t-12___awixS {
  padding-top: 12px !important;
}

.TableEmptyView-module__p-t-16___ROdeS {
  padding-top: 16px !important;
}

.TableEmptyView-module__p-t-18___RuGWH {
  padding-top: 18px !important;
}

.TableEmptyView-module__p-t-20___KXGwe {
  padding-top: 20px !important;
}

.TableEmptyView-module__p-t-30___P341F {
  padding-top: 30px !important;
}

.TableEmptyView-module__p-t-40___ht4_T {
  padding-top: 40px !important;
}

.TableEmptyView-module__p-t-50___Y5O9E {
  padding-top: 50px !important;
}

.TableEmptyView-module__p-l-20___zNMtl {
  padding-left: 20px !important;
}

.TableEmptyView-module__p-l-30___xdLoW {
  padding-left: 30px !important;
}

.TableEmptyView-module__p-l-40___Bi1Ht {
  padding-left: 40px !important;
}

.TableEmptyView-module__p-r-16___PGzuE {
  padding-right: 16px !important;
}

.TableEmptyView-module__p-r-20___TgOMs {
  padding-right: 20px !important;
}

.TableEmptyView-module__p-r-30___AnuXq {
  padding-right: 30px !important;
}

.TableEmptyView-module__p-r-50___BUo69 {
  padding-right: 50px !important;
}

.TableEmptyView-module__p-r-60___vt9z1 {
  padding-right: 60px !important;
}

.TableEmptyView-module__m-b-1___ws5_i {
  margin-bottom: 1px !important;
}

.TableEmptyView-module__m-b-2___v20nZ {
  margin-bottom: 2px !important;
}

.TableEmptyView-module__m-b-6___LiMxp {
  margin-bottom: 6px !important;
}

.TableEmptyView-module__m-b-8___JTu40 {
  margin-bottom: 8px !important;
}

.TableEmptyView-module__m-b-10___XfuD_ {
  margin-bottom: 10px !important;
}

.TableEmptyView-module__m-b-14____uBJX {
  margin-bottom: 14px !important;
}

.TableEmptyView-module__m-b-16___jtZIT {
  margin-bottom: 16px !important;
}

.TableEmptyView-module__m-b-20___eWrQe {
  margin-bottom: 20px !important;
}

.TableEmptyView-module__m-b-22___Hmxkh {
  margin-bottom: 22px !important;
}

.TableEmptyView-module__m-b-24___BqGsb {
  margin-bottom: 24px !important;
}

.TableEmptyView-module__m-b-30____JNE7 {
  margin-bottom: 30px !important;
}

.TableEmptyView-module__m-b-32___RZoCb {
  margin-bottom: 32px !important;
}

.TableEmptyView-module__m-b-40____XMZx {
  margin-bottom: 40px !important;
}

.TableEmptyView-module__m-t-2___JJnAM {
  margin-top: 2px !important;
}

.TableEmptyView-module__m-t-3___G8i8Q {
  margin-top: 3px !important;
}

.TableEmptyView-module__m-t-4___IDL5l {
  margin-top: 4px !important;
}

.TableEmptyView-module__m-t-5___ha70a {
  margin-top: 5px !important;
}

.TableEmptyView-module__m-t-8___yxhui {
  margin-top: 8px !important;
}

.TableEmptyView-module__m-t-10___b36Yo {
  margin-top: 10px !important;
}

.TableEmptyView-module__m-t-15___gG8Wk {
  margin-top: 15px !important;
}

.TableEmptyView-module__m-t-16___Ws0Vn {
  margin-top: 16px !important;
}

.TableEmptyView-module__m-t-20___UfQs9 {
  margin-top: 20px !important;
}

.TableEmptyView-module__m-t-22___ep7pN {
  margin-top: 22px !important;
}

.TableEmptyView-module__m-t-30___eDybB {
  margin-top: 30px !important;
}

.TableEmptyView-module__m-t-32___It5Cz {
  margin-top: 32px !important;
}

.TableEmptyView-module__m-l-auto___vRBLg {
  margin-left: auto !important;
}

.TableEmptyView-module__m-l-4___yw3_7 {
  margin-left: 4px !important;
}

.TableEmptyView-module__m-l-5___jWPiv {
  margin-left: 5px !important;
}

.TableEmptyView-module__m-l-6___TXfJ7 {
  margin-left: 6px !important;
}

.TableEmptyView-module__m-l-8___pFgIT {
  margin-left: 8px !important;
}

.TableEmptyView-module__m-l-10___IgGk3 {
  margin-left: 10px !important;
}

.TableEmptyView-module__m-l-16___MM6gP {
  margin-left: 16px !important;
}

.TableEmptyView-module__m-l-20___HE0Ry {
  margin-left: 20px !important;
}

.TableEmptyView-module__m-l-24___hHrvB {
  margin-left: 24px !important;
}

.TableEmptyView-module__m-l-30___B8uUA {
  margin-left: 30px !important;
}

.TableEmptyView-module__m-l-35___TSLJI {
  margin-left: 35px !important;
}

.TableEmptyView-module__m-l-40___JoYTZ {
  margin-left: 40px !important;
}

.TableEmptyView-module__m-r-8___isfjj {
  margin-right: 8px !important;
}

.TableEmptyView-module__m-r-10___gip7o {
  margin-right: 10px !important;
}

.TableEmptyView-module__m-r-16___vKZsu {
  margin-right: 16px !important;
}

.TableEmptyView-module__m-r-20___gUvnF {
  margin-right: 20px !important;
}

.TableEmptyView-module__m-r-24___qFF8Y {
  margin-right: 24px !important;
}

.TableEmptyView-module__m-r-30___J8gWC {
  margin-right: 30px !important;
}

.TableEmptyView-module__m-r-40___nyeko {
  margin-right: 40px !important;
}

.TableEmptyView-module__border-r-3___AEveo {
  border-radius: 3px !important;
}

.TableEmptyView-module__border-r-4___YpUTa {
  border-radius: 4px !important;
}

.TableEmptyView-module__border-r-6___lbBi_ {
  border-radius: 6px !important;
}

.TableEmptyView-module__border-r-10___rEb7q {
  border-radius: 10px !important;
}

.TableEmptyView-module__border-r-12___HXtf2 {
  border-radius: 12px !important;
}

.TableEmptyView-module__border-r-16___RqYW8 {
  border-radius: 16px !important;
}

.TableEmptyView-module__border-r-50___akotl {
  border-radius: 50% !important;
}

.TableEmptyView-module__primary-border___Yo5tx {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TableEmptyView-module__primary-border-b___UJKNY {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TableEmptyView-module__primary-border-t___gW5Pq {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TableEmptyView-module__primary-border-l___tyJAo {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TableEmptyView-module__primary-border-r___ugzcY {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TableEmptyView-module__secondary-border___eQn8j {
  border: 1px solid #637768;
}

.TableEmptyView-module__secondary-border-b___GcPj4 {
  border-bottom: 1px solid #637768;
}

.TableEmptyView-module__secondary-border-t___BKvtZ {
  border-top: 1px solid #637768;
}

.TableEmptyView-module__secondary-border-l___yhGnb {
  border-left: 1px solid #637768;
}

.TableEmptyView-module__secondary-border-r___N3ObM {
  border-right: 1px solid #637768;
}

.TableEmptyView-module__gap-0___mb9FD {
  gap: 0 !important;
}

.TableEmptyView-module__gap-2___fxYLx {
  gap: 2px !important;
}

.TableEmptyView-module__gap-4___wi2su {
  gap: 4px !important;
}

.TableEmptyView-module__gap-5___xSMFx {
  gap: 5px !important;
}

.TableEmptyView-module__gap-6___RJKLH {
  gap: 6px !important;
}

.TableEmptyView-module__gap-8___SPwsd {
  gap: 8px !important;
}

.TableEmptyView-module__gap-10___VNY5v {
  gap: 10px !important;
}

.TableEmptyView-module__gap-12___cnhT1 {
  gap: 12px !important;
}

.TableEmptyView-module__gap-14___ucGB8 {
  gap: 14px !important;
}

.TableEmptyView-module__gap-16___EbMeD {
  gap: 16px !important;
}

.TableEmptyView-module__gap-18___NFDJU {
  gap: 18px !important;
}

.TableEmptyView-module__gap-20___TgwgY {
  gap: 20px !important;
}

.TableEmptyView-module__gap-24___J1N52 {
  gap: 24px !important;
}

.TableEmptyView-module__gap-26___iHSUT {
  gap: 26px !important;
}

.TableEmptyView-module__gap-30___hRPOa {
  gap: 30px !important;
}

.TableEmptyView-module__gap-32___XBpCP {
  gap: 32px !important;
}

.TableEmptyView-module__gap-40___dKxb6 {
  gap: 40px !important;
}

.TableEmptyView-module__gap-50___VGraW {
  gap: 50px !important;
}

.TableEmptyView-module__flex-1___EsF45 {
  flex: 1;
}

.TableEmptyView-module__flex-none___mnloj {
  flex: none !important;
}

.TableEmptyView-module__flex-column___NY4vq {
  display: flex;
  flex-direction: column !important;
}

.TableEmptyView-module__flex-row___OuoVK {
  display: flex;
  flex-direction: row !important;
}

.TableEmptyView-module__vertically-centered___qEOl8 {
  display: flex;
  align-items: center !important;
}

.TableEmptyView-module__horizontally-centered___lAHYH {
  display: flex;
  justify-content: center !important;
}

.TableEmptyView-module__horizontally-end___sFiT9 {
  display: flex;
  justify-content: end !important;
}

.TableEmptyView-module__vertically-start___iF1e0 {
  display: flex;
  align-items: start !important;
}

.TableEmptyView-module__space-between___jjByp {
  display: flex;
  justify-content: space-between !important;
}

.TableEmptyView-module__flex-wrap___RLkUr {
  flex-wrap: wrap !important;
}

.TableEmptyView-module__height-100___Wccrt {
  height: 100%;
}

.TableEmptyView-module__width-50___Sj6tR {
  width: 50% !important;
}

.TableEmptyView-module__width-100___h7o_Q {
  width: 100%;
}

.TableEmptyView-module__cursor-pointer___dKDLH {
  cursor: pointer;
}

.TableEmptyView-module__cursor-not-allowed___Euhdw {
  cursor: not-allowed !important;
}

.TableEmptyView-module__absolute-centered___D5Uf_ {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TableEmptyView-module__absolute___hpzxL {
  position: absolute;
}

.TableEmptyView-module__relative___dVED8 {
  position: relative;
}

.TableEmptyView-module__fixed___kin28 {
  position: fixed;
}

.TableEmptyView-module__visible___y53A1 {
  opacity: 1;
}

.TableEmptyView-module__invisible___Jdl6C {
  opacity: 0;
}

.TableEmptyView-module__col-90___OEYwm {
  width: 90% !important;
}

.TableEmptyView-module__col-auto___I9dBo {
  width: auto !important;
}

.TableEmptyView-module__medical-tabs___uy4xS {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TableEmptyView-module__medical-table-new___OFQ8N {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableEmptyView-module__medical-table-new___OFQ8N:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableEmptyView-module__medical-table-new___OFQ8N::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableEmptyView-module__medical-table-new___OFQ8N::-webkit-scrollbar-track {
  display: none;
}
.TableEmptyView-module__medical-table-new___OFQ8N.TableEmptyView-module__no-pagination___MIquW {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TableEmptyView-module__medical-table-new___OFQ8N.TableEmptyView-module__no-pagination___MIquW:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TableEmptyView-module__medical-table-new___OFQ8N.TableEmptyView-module__no-pagination___MIquW::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TableEmptyView-module__medical-table-new___OFQ8N.TableEmptyView-module__no-pagination___MIquW::-webkit-scrollbar-track {
  display: none;
}

.TableEmptyView-module__medical-table-empty___DggN4 {
  padding: 14px 40px !important;
}

.TableEmptyView-module__icon-btn___cp7rn {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TableEmptyView-module__search-icon___MKJiR {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TableEmptyView-module__disable-select___WHeAx {
  user-select: none;
}

.TableEmptyView-module__break-word___WsyEz {
  word-break: break-word;
}

.TableEmptyView-module__popup-clear-btn___TMHMv {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TableEmptyView-module__scroll-m-b-20___Utsdz {
  scroll-margin-bottom: 20px;
}

.TableEmptyView-module__text___NeiL3 {
  display: flex;
  font-family: var(--font-family);
  font-weight: 400;
  line-height: 17px;
  font-style: italic;
  color: #365844;
  padding: 14px 10px;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/TableEmptyView/TableEmptyView.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,aAAA;EEuBA,+BApBO;EAqBP,gBAFmD;EFpBnD,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AA+pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.text {\n  display: flex;\n  @include get-font($roboto);\n  line-height: 17px;\n  font-style: italic;\n  color: #365844;\n  padding: 14px 10px;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TableEmptyView-module__font-s-10___AbABz`,
	"fontS12": `TableEmptyView-module__font-s-12___mc9Tr`,
	"fontS13": `TableEmptyView-module__font-s-13___P2l7I`,
	"fontS14": `TableEmptyView-module__font-s-14___X31Qn`,
	"fontS15": `TableEmptyView-module__font-s-15___SNZ7F`,
	"fontS16": `TableEmptyView-module__font-s-16___fIS2K`,
	"fontS18": `TableEmptyView-module__font-s-18___abvKK`,
	"fontS20": `TableEmptyView-module__font-s-20___xHEMl`,
	"fontS22": `TableEmptyView-module__font-s-22___La9Mj`,
	"fontS28": `TableEmptyView-module__font-s-28___X9qj0`,
	"fontW400": `TableEmptyView-module__font-w-400___toOUq`,
	"fontW500": `TableEmptyView-module__font-w-500___Zgfup`,
	"fontW600": `TableEmptyView-module__font-w-600___wLqwx`,
	"fontW700": `TableEmptyView-module__font-w-700___kJ_rR`,
	"p5": `TableEmptyView-module__p-5___I46Uc`,
	"p12": `TableEmptyView-module__p-12___Ttv9S`,
	"p16": `TableEmptyView-module__p-16___qsYUC`,
	"p30": `TableEmptyView-module__p-30___WnAYI`,
	"pB0": `TableEmptyView-module__p-b-0___ESBNp`,
	"pB5": `TableEmptyView-module__p-b-5___jkoOv`,
	"pB10": `TableEmptyView-module__p-b-10___WUFf1`,
	"pB12": `TableEmptyView-module__p-b-12___HfEkX`,
	"pB16": `TableEmptyView-module__p-b-16___CsjH7`,
	"pB18": `TableEmptyView-module__p-b-18___kWhQU`,
	"pB20": `TableEmptyView-module__p-b-20___nYPT8`,
	"pB25": `TableEmptyView-module__p-b-25___kLpqv`,
	"pB30": `TableEmptyView-module__p-b-30___vyOlm`,
	"pB50": `TableEmptyView-module__p-b-50___vgOyi`,
	"pT0": `TableEmptyView-module__p-t-0___hZVvY`,
	"pT12": `TableEmptyView-module__p-t-12___awixS`,
	"pT16": `TableEmptyView-module__p-t-16___ROdeS`,
	"pT18": `TableEmptyView-module__p-t-18___RuGWH`,
	"pT20": `TableEmptyView-module__p-t-20___KXGwe`,
	"pT30": `TableEmptyView-module__p-t-30___P341F`,
	"pT40": `TableEmptyView-module__p-t-40___ht4_T`,
	"pT50": `TableEmptyView-module__p-t-50___Y5O9E`,
	"pL20": `TableEmptyView-module__p-l-20___zNMtl`,
	"pL30": `TableEmptyView-module__p-l-30___xdLoW`,
	"pL40": `TableEmptyView-module__p-l-40___Bi1Ht`,
	"pR16": `TableEmptyView-module__p-r-16___PGzuE`,
	"pR20": `TableEmptyView-module__p-r-20___TgOMs`,
	"pR30": `TableEmptyView-module__p-r-30___AnuXq`,
	"pR50": `TableEmptyView-module__p-r-50___BUo69`,
	"pR60": `TableEmptyView-module__p-r-60___vt9z1`,
	"mB1": `TableEmptyView-module__m-b-1___ws5_i`,
	"mB2": `TableEmptyView-module__m-b-2___v20nZ`,
	"mB6": `TableEmptyView-module__m-b-6___LiMxp`,
	"mB8": `TableEmptyView-module__m-b-8___JTu40`,
	"mB10": `TableEmptyView-module__m-b-10___XfuD_`,
	"mB14": `TableEmptyView-module__m-b-14____uBJX`,
	"mB16": `TableEmptyView-module__m-b-16___jtZIT`,
	"mB20": `TableEmptyView-module__m-b-20___eWrQe`,
	"mB22": `TableEmptyView-module__m-b-22___Hmxkh`,
	"mB24": `TableEmptyView-module__m-b-24___BqGsb`,
	"mB30": `TableEmptyView-module__m-b-30____JNE7`,
	"mB32": `TableEmptyView-module__m-b-32___RZoCb`,
	"mB40": `TableEmptyView-module__m-b-40____XMZx`,
	"mT2": `TableEmptyView-module__m-t-2___JJnAM`,
	"mT3": `TableEmptyView-module__m-t-3___G8i8Q`,
	"mT4": `TableEmptyView-module__m-t-4___IDL5l`,
	"mT5": `TableEmptyView-module__m-t-5___ha70a`,
	"mT8": `TableEmptyView-module__m-t-8___yxhui`,
	"mT10": `TableEmptyView-module__m-t-10___b36Yo`,
	"mT15": `TableEmptyView-module__m-t-15___gG8Wk`,
	"mT16": `TableEmptyView-module__m-t-16___Ws0Vn`,
	"mT20": `TableEmptyView-module__m-t-20___UfQs9`,
	"mT22": `TableEmptyView-module__m-t-22___ep7pN`,
	"mT30": `TableEmptyView-module__m-t-30___eDybB`,
	"mT32": `TableEmptyView-module__m-t-32___It5Cz`,
	"mLAuto": `TableEmptyView-module__m-l-auto___vRBLg`,
	"mL4": `TableEmptyView-module__m-l-4___yw3_7`,
	"mL5": `TableEmptyView-module__m-l-5___jWPiv`,
	"mL6": `TableEmptyView-module__m-l-6___TXfJ7`,
	"mL8": `TableEmptyView-module__m-l-8___pFgIT`,
	"mL10": `TableEmptyView-module__m-l-10___IgGk3`,
	"mL16": `TableEmptyView-module__m-l-16___MM6gP`,
	"mL20": `TableEmptyView-module__m-l-20___HE0Ry`,
	"mL24": `TableEmptyView-module__m-l-24___hHrvB`,
	"mL30": `TableEmptyView-module__m-l-30___B8uUA`,
	"mL35": `TableEmptyView-module__m-l-35___TSLJI`,
	"mL40": `TableEmptyView-module__m-l-40___JoYTZ`,
	"mR8": `TableEmptyView-module__m-r-8___isfjj`,
	"mR10": `TableEmptyView-module__m-r-10___gip7o`,
	"mR16": `TableEmptyView-module__m-r-16___vKZsu`,
	"mR20": `TableEmptyView-module__m-r-20___gUvnF`,
	"mR24": `TableEmptyView-module__m-r-24___qFF8Y`,
	"mR30": `TableEmptyView-module__m-r-30___J8gWC`,
	"mR40": `TableEmptyView-module__m-r-40___nyeko`,
	"borderR3": `TableEmptyView-module__border-r-3___AEveo`,
	"borderR4": `TableEmptyView-module__border-r-4___YpUTa`,
	"borderR6": `TableEmptyView-module__border-r-6___lbBi_`,
	"borderR10": `TableEmptyView-module__border-r-10___rEb7q`,
	"borderR12": `TableEmptyView-module__border-r-12___HXtf2`,
	"borderR16": `TableEmptyView-module__border-r-16___RqYW8`,
	"borderR50": `TableEmptyView-module__border-r-50___akotl`,
	"primaryBorder": `TableEmptyView-module__primary-border___Yo5tx`,
	"primaryBorderB": `TableEmptyView-module__primary-border-b___UJKNY`,
	"primaryBorderT": `TableEmptyView-module__primary-border-t___gW5Pq`,
	"primaryBorderL": `TableEmptyView-module__primary-border-l___tyJAo`,
	"primaryBorderR": `TableEmptyView-module__primary-border-r___ugzcY`,
	"secondaryBorder": `TableEmptyView-module__secondary-border___eQn8j`,
	"secondaryBorderB": `TableEmptyView-module__secondary-border-b___GcPj4`,
	"secondaryBorderT": `TableEmptyView-module__secondary-border-t___BKvtZ`,
	"secondaryBorderL": `TableEmptyView-module__secondary-border-l___yhGnb`,
	"secondaryBorderR": `TableEmptyView-module__secondary-border-r___N3ObM`,
	"gap0": `TableEmptyView-module__gap-0___mb9FD`,
	"gap2": `TableEmptyView-module__gap-2___fxYLx`,
	"gap4": `TableEmptyView-module__gap-4___wi2su`,
	"gap5": `TableEmptyView-module__gap-5___xSMFx`,
	"gap6": `TableEmptyView-module__gap-6___RJKLH`,
	"gap8": `TableEmptyView-module__gap-8___SPwsd`,
	"gap10": `TableEmptyView-module__gap-10___VNY5v`,
	"gap12": `TableEmptyView-module__gap-12___cnhT1`,
	"gap14": `TableEmptyView-module__gap-14___ucGB8`,
	"gap16": `TableEmptyView-module__gap-16___EbMeD`,
	"gap18": `TableEmptyView-module__gap-18___NFDJU`,
	"gap20": `TableEmptyView-module__gap-20___TgwgY`,
	"gap24": `TableEmptyView-module__gap-24___J1N52`,
	"gap26": `TableEmptyView-module__gap-26___iHSUT`,
	"gap30": `TableEmptyView-module__gap-30___hRPOa`,
	"gap32": `TableEmptyView-module__gap-32___XBpCP`,
	"gap40": `TableEmptyView-module__gap-40___dKxb6`,
	"gap50": `TableEmptyView-module__gap-50___VGraW`,
	"flex1": `TableEmptyView-module__flex-1___EsF45`,
	"flexNone": `TableEmptyView-module__flex-none___mnloj`,
	"flexColumn": `TableEmptyView-module__flex-column___NY4vq`,
	"flexRow": `TableEmptyView-module__flex-row___OuoVK`,
	"verticallyCentered": `TableEmptyView-module__vertically-centered___qEOl8`,
	"horizontallyCentered": `TableEmptyView-module__horizontally-centered___lAHYH`,
	"horizontallyEnd": `TableEmptyView-module__horizontally-end___sFiT9`,
	"verticallyStart": `TableEmptyView-module__vertically-start___iF1e0`,
	"spaceBetween": `TableEmptyView-module__space-between___jjByp`,
	"flexWrap": `TableEmptyView-module__flex-wrap___RLkUr`,
	"height100": `TableEmptyView-module__height-100___Wccrt`,
	"width50": `TableEmptyView-module__width-50___Sj6tR`,
	"width100": `TableEmptyView-module__width-100___h7o_Q`,
	"cursorPointer": `TableEmptyView-module__cursor-pointer___dKDLH`,
	"cursorNotAllowed": `TableEmptyView-module__cursor-not-allowed___Euhdw`,
	"absoluteCentered": `TableEmptyView-module__absolute-centered___D5Uf_`,
	"absolute": `TableEmptyView-module__absolute___hpzxL`,
	"relative": `TableEmptyView-module__relative___dVED8`,
	"fixed": `TableEmptyView-module__fixed___kin28`,
	"visible": `TableEmptyView-module__visible___y53A1`,
	"invisible": `TableEmptyView-module__invisible___Jdl6C`,
	"col90": `TableEmptyView-module__col-90___OEYwm`,
	"colAuto": `TableEmptyView-module__col-auto___I9dBo`,
	"medicalTabs": `TableEmptyView-module__medical-tabs___uy4xS`,
	"medicalTableNew": `TableEmptyView-module__medical-table-new___OFQ8N`,
	"noPagination": `TableEmptyView-module__no-pagination___MIquW`,
	"medicalTableEmpty": `TableEmptyView-module__medical-table-empty___DggN4`,
	"iconBtn": `TableEmptyView-module__icon-btn___cp7rn`,
	"searchIcon": `TableEmptyView-module__search-icon___MKJiR`,
	"disableSelect": `TableEmptyView-module__disable-select___WHeAx`,
	"breakWord": `TableEmptyView-module__break-word___WsyEz`,
	"popupClearBtn": `TableEmptyView-module__popup-clear-btn___TMHMv`,
	"scrollMB20": `TableEmptyView-module__scroll-m-b-20___Utsdz`,
	"text": `TableEmptyView-module__text___NeiL3`
};
module.exports = ___CSS_LOADER_EXPORT___;
